import React, { useState, useEffect } from 'react'
import { KnowledgeModel } from '../../../model/knowledge.model'
import './SearchedCell.css'
interface SearchedCellProps {
    dataSource?: KnowledgeModel
    onClick?: () => void
}
const SearchedCell: React.FC<SearchedCellProps> = (props) => {
    const { dataSource, onClick } = props
    const [searchedContent, setSearchedContent] = useState('')
    useEffect(() => {
        const parseSearchedContent = () => {
            const highlightTagName = '<em>'
            if (dataSource) {
                // 如果搜索内容在标题中
                if (
                    dataSource.k_title &&
                    dataSource.k_title.indexOf(highlightTagName) > -1
                ) {
                    setSearchedContent(dataSource.k_title)
                    return
                }
                // 如果搜索内容在相似问中
                if (dataSource.KQuestions && dataSource.KQuestions.length > 0) {
                    let searchedQuestions = dataSource.KQuestions.filter(
                        (item) => item.k_question.indexOf(highlightTagName) > -1
                    )
                    if (searchedQuestions.length > 0) {
                        setSearchedContent(searchedQuestions[0].k_question)
                        return
                    }
                }
                // 如果搜索内容在答案中
                if (dataSource.KAnswers && dataSource.KAnswers.length > 0) {
                    let searchedAnswers = dataSource.KAnswers.filter(
                        (item) => item.k_answer.indexOf(highlightTagName) > -1
                    )
                    if (searchedAnswers.length > 0) {
                        setSearchedContent(searchedAnswers[0].k_answer)
                    }
                }
            }
        }
        parseSearchedContent()
    }, [dataSource])
    if (!searchedContent) return null
    return (
        <div className='searched-knowledge-cell' onClick={onClick}>
            <p
                dangerouslySetInnerHTML={{
                    __html: searchedContent,
                }}
                className='ellipsis'
            ></p>
        </div>
    )
}

export default SearchedCell
